import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import ReactPlayer from "react-player";

//style
import "./_watchPage.scss";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { Col, Row } from "react-bootstrap";

//components
import Comments from "../../components/comments/Comments";
import VideoHorizontal from "../../components/videoHorizontal/VideoHorizontal";
import VideoMetaData from "../../components/videoMetaData/VideoMetaData";
import { useWindowSize } from "../../components/customHooks/useWindowSize";

import InfiniteScroll from "react-infinite-scroll-component";

import { getVideoById } from "../../api/videoApi";

//import { getRelatedVideos } from "../../store/actions/videoAction";
import { getRelatedVideos } from "../../api/videoApi";
import { setError } from "../../store/slices/videoSlice";

const WatchPage = () => {
  const { id } = useParams();
  const [video, setVideo] = useState(null);
  const [error, setError] = useState(null);
  const [videos, setVideos] = useState([]);
  const [nextPageToken, setNextPageToken] = useState(null);
  const largeScreen = useWindowSize(990);
  const dispatch = useDispatch();

  useEffect(() => {
    getVideoById(id)
      .then((d) => {
        setVideo(d);
      })
      .catch((error) => {
        dispatch(setError({ error: error }));
      });
    getRelatedVideos()
      .then((d) => {
        setVideos(d.videos);
        setNextPageToken(d.nextPageToken);
      })
      .catch((error) => {
        dispatch(setError({ error: error }));
      });
  }, [id]);

  const nextVideos = () => {
    getRelatedVideos(nextPageToken)
      .then((d) => {
        setVideos([...videos, ...d.videos]);
        setNextPageToken(d.nextPageToken);
      })
      .catch((error) => {
        dispatch(setError({ error: error }));
      });
  };

  const moreVideos = (type = "button") => {
    if (type == "scroll" && !largeScreen) {
      return;
    }
    nextVideos();
  };

  return (
    <>
      <Row className="d-lg-block">
        <Helmet title={video?.snippet?.title} />
        <Col lg={8} md={12} className="float-start">
          <div className="watchScreen__wrapper">
            <ReactPlayer
              url={`https://www.youtube.com/watch?v=${id}`}
              className="watchScreen__player"
              width="100%"
              height="100%"
            />
          </div>
          {video ? (
            <VideoMetaData video={video} videoId={id} />
          ) : (
            <h6>Loading...</h6>
          )}
        </Col>
        <Col lg={4} md={12} className="relatedVideos float-end">
          {videos.length ? (
            <>
              <div>
                <InfiniteScroll
                  dataLength={videos.length}
                  next={moreVideos("scroll")}
                  hasMore={true}
                  loader={
                    largeScreen && (
                      <div className="spinner-border text-danger d-block mx-auto"></div>
                    )
                  }
                  className="row"
                >
                  {videos
                    ?.filter((video) => video.snippet)
                    .map((video) => (
                      <VideoHorizontal video={video} key={video.id.videoId} />
                    ))}
                </InfiniteScroll>
              </div>
            </>
          ) : (
            <div className="relatedVideos">
              <SkeletonTheme color="#343a40" highlightColor="#3c4147">
                <Skeleton width="60%" height="130px" count={15} />
              </SkeletonTheme>
            </div>
          )}
          {!largeScreen & videos.length ? (
            <div className="relatedVideos__show_more_videos">
              <button
                classname="show_more"
                onClick={moreVideos}
                className="w-100 my-2 p-2"
              >
                Show more
              </button>
            </div>
          ) : (
            ""
          )}
        </Col>
        <Col lg={8} md={12} className="float-start">
          <Comments
            videoId={id}
            totalComments={video?.statistics?.commentCount}
          />
        </Col>
      </Row>
    </>
  );
};

export default WatchPage;
